import { PhaseProductsManager } from "@/components/admin/PhaseProductsManager";

export default function PhaseProducts() {
  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-3xl font-bold text-foreground">Phase Products Manager</h1>
        <p className="text-muted-foreground mt-2">
          Organize products by installation phase for the sales presentation mode
        </p>
      </div>

      <PhaseProductsManager />
    </div>
  );
}
